import {
    jwt,
    isUserLoggedIn as jwtIsUserLoggedIn,
    silentLogin as jwtSilentLogin,
    forceLogout as jwtForceLogout
} from '@/auth/jwt/useJwt'

import store from '@/store'

import get from "lodash.get";


/**
 * Return prepared authentication instance for api
 * Override to use other authentication system
 */

export const AuthConfig = jwt;

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
export const userDataExist = () => {
    return Boolean(get(store.state.auth, 'user.id') && get(store.state.auth, 'user.info.email'))
}

export const isUserLoggedIn = () => {
    return Boolean(jwtIsUserLoggedIn())
}

export const silentLogin = () => {
    return jwtSilentLogin()
}

export const forceLogout = () => {
    return jwtForceLogout()
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}

